// @flow
export { default } from './PostTags';



// WEBPACK FOOTER //
// ./src/components/post/PostTags/index.js